/* eslint-disable no-unused-vars */
import { createStore, useStore as vuexUseStore } from 'vuex'
import TiposVeiculosConstant from '@/constants/TiposVeiculosConstant'
import Mutations from '@/store/Mutations'
import Actions from '@/store/Actions'
import RequestProvider from "@/providers/RequestProvider";
import FuncoesHelper from "@/helpers/FuncoesHelper";
import Rotas from "@/router/Rotas";
import ComponenteDadosAtendimentoService from '@/services/componentes/ComponenteDadosAtendimentoService';
import EtapasComponentesConstant from '@/constants/EtapasComponentesConstant';
import CoordenadasFotoConstant from '@/constants/CoordenadasFotoConstant';

const state = {
	identificador: '',
	preview: false,
	dadosAtendimento: [],
	dadosPrestador: [],
	tipoVeiculo: TiposVeiculosConstant.AUTOMOVEL,
	idChecklistResposta: null,
	recebimentoFinalizado: 'N',
	dataHorarioFinalizacao: null,
	pdfChecklist: null,
	modulos: [],
	fotosTemp: {},
	coordenadasTemp: CoordenadasFotoConstant.COORDENADAS
}

const actions = {
	async [Actions.OBTER_CHECKLIST]({ commit }, { identificador, localRealizacao, etapa, parametro = null }) {
		this.state.identificador = identificador

		if (parametro === Rotas.ASSINATURA.chave) {
			FuncoesHelper.pushRouter(Rotas.ASSINATURA.nome, { identificador: identificador, signatario: parametro })
			return
		}

		RequestProvider.get(`/obterDadosChecklistModular/${identificador}`)
			.then(({ data: checklist }) => {
				commit(Mutations.DEFINE_PREVIEW, checklist.preview)
				commit(Mutations.DEFINE_DADOS_ATENDIMENTO, checklist.dadosAtendimento)
				commit(Mutations.DEFINE_DADOS_PRESTADOR, checklist.dadosPrestador)

				if (checklist.preview == false) {
					commit(Mutations.DEFINE_RECEBIMENTO_FINALIZADO, checklist.dadosResposta)
				}

				commit(Mutations.DEFINE_MODULOS, checklist)

				if (state.recebimentoFinalizado == 'N') {
					switch (etapa) {
						case Rotas.RESUMO.chave:
							FuncoesHelper.pushRouter(Rotas.RESUMO.nome, { identificador: this.state.identificador })
							return
						case Rotas.MODULOS.chave:
							FuncoesHelper.pushRouter(Rotas.MODULOS.nome, { identificador: this.state.identificador })
							return
					}
					const moduloAtual = state.modulos.find(module => {
						return checklist.preview && checklist.preview == true
							? module.localRealizacao.toLowerCase() == localRealizacao
							: module.recebimentoFinalizado == 'N'
					});

					if(!moduloAtual) {
						FuncoesHelper.pushRouter(Rotas.MODULOS.nome, { identificador: this.state.identificador })
						return
					}

					FuncoesHelper.pushRouter(Rotas.ETAPAS.nome, {
						identificador: this.state.identificador,
						localRealizacao: moduloAtual.localRealizacao.toLowerCase(),
						modulo: moduloAtual.idChecklistModulo,
						etapa: etapa
					})
				} else {
					FuncoesHelper.pushRouter(Rotas.MODULOS.nome, { identificador: this.state.identificador })
				}
			})
			.catch((error) => {
				FuncoesHelper.pushRouter(Rotas.NOT_FOUND.nome, { pathMatch: this.state.identificador })
			})
	},
	[Actions.SALVAR_ETAPA_CHECKLIST]({ commit, state }, { localRealizacao, modulo, etapa, respostas }) {
		const { identificador, idChecklistResposta } = state;
		const moduloAtual = state.modulos.find(module => module.idChecklistModulo == modulo);
		const { idChecklistModulo, idChecklistModuloResposta, recebimentoFinalizado, etapas } = moduloAtual;

		const respostasEtapa = Actions.formatarRespostasEtapa(respostas);
		const etapaRespondida = Actions.obterEtapaRespondida(etapas, etapa, modulo);
		const dadosRequisicao = {
			idChecklistModulo,
			dadosEtapa: {
				totalEtapas: etapas.totalEtapas,
				etapa: etapaRespondida,
			},
			dadosResposta: {
				idChecklistResposta,
				idChecklistModuloResposta,
				recebimentoFinalizado,
				respostas: respostasEtapa,
			},
		};

		RequestProvider.post(`/salvarEtapasChecklistModular/${identificador}`, dadosRequisicao)
			.then(({ data: resposta }) => {
				commit(Mutations.DEFINE_ETAPA_SALVA, resposta);
			})
			.catch(() => {
				FuncoesHelper.pushRouter(Rotas.NOT_FOUND.nome, { pathMatch: identificador });
			});
	},
	async [Actions.FINALIZAR_CHECKLIST]({ commit, state }, { modulo }) {
		const { identificador, idChecklistResposta } = state;

		const moduloAtual = state.modulos.find(module => module.idChecklistModulo == modulo);
		const { idChecklistModulo, idChecklistModuloResposta, etapas } = moduloAtual;

		const assinaturas = moduloAtual.assinaturas.respostas;
		const respostasChecklist = Actions.formatarRespostasFinalizacao(etapas.componentes);
		const { data: resposta } = await RequestProvider.post(`/finalizarChecklistModular/${identificador}`, {
			idChecklistModulo,
			idChecklistResposta,
			idChecklistModuloResposta,
			dadosResposta: respostasChecklist,
			assinaturas
		})
		commit(Mutations.DEFINE_CHECKLIST_RESPOSTA, moduloAtual)
		return resposta;
	},
	[Actions.SALVAR_TIPO_VEICULO]({ commit }, tipoVeiculo) {
		commit(Mutations.DEFINE_TIPO_VEICULO, tipoVeiculo)
	},
	[Actions.SALVAR_FOTOS]({ commit, state }, { localRealizacao, modulo, etapa, idComponente, foto }) {
		const { identificador, idChecklistResposta } = state;
		const moduloAtual = state.modulos.find(module => module.idChecklistModulo == modulo);
		const { idChecklistModulo, idChecklistModuloResposta, recebimentoFinalizado, etapas } = moduloAtual;

		const respostas = Actions.formatarRespostasEtapa(moduloAtual.etapas.componentes[etapa]);
		const etapaRespondida = Actions.obterEtapaRespondida(etapas, etapa, modulo);

		const dadosRequisicao = {
			dadosEtapa: {
				totalEtapas: etapas.totalEtapas,
				etapa: etapaRespondida
			},
			dadosResposta: {
				idChecklistResposta,
				idChecklistModuloResposta,
				recebimentoFinalizado,
				respostas
			},
			idChecklistModulo,
			idComponente,
			arquivos: foto
		}

		RequestProvider.post(`/salvarFotosChecklistModular/${identificador}`, dadosRequisicao)
			.then(({ data: resposta }) => {
				commit(Mutations.DEFINE_IMAGENS, resposta);
				FuncoesHelper.pushRouter(Rotas.ETAPAS.nome,
					{
						identificador: this.state.identificador,
						modulo: modulo,
						localRealizacao: localRealizacao,
						etapa: etapa
					}
				);

				state.fotosTemp = {};
			}).catch(error => {
				console.log(error);
			})
	},
	[Actions.SALVAR_AVARIAS]({ commit, state }, { localRealizacao, modulo, etapa, idComponente, avarias }) {
		const { identificador, idChecklistResposta } = state;
		const moduloAtual = state.modulos.find(module => module.idChecklistModulo == modulo);
		const { idChecklistModulo, idChecklistModuloResposta, recebimentoFinalizado, etapas } = moduloAtual;

		const respostas = Actions.formatarRespostasEtapa(moduloAtual.etapas.componentes[etapa]);
		const etapaRespondida = Actions.obterEtapaRespondida(etapas, etapa, modulo);

		const dadosRequisicao = {
			dadosEtapa: {
				totalEtapas: etapas.totalEtapas,
				etapa: etapaRespondida
			},
			dadosResposta: {
				idChecklistResposta,
				idChecklistModuloResposta,
				recebimentoFinalizado,
				respostas
			},
			idChecklistModulo,
			idComponente,
			arquivos: avarias
		}

		RequestProvider.post(`/salvarAvariasChecklistModular/${identificador}`, dadosRequisicao)
			.then(({ data: resposta }) => {
				commit(Mutations.DEFINE_IMAGENS, resposta)
				FuncoesHelper.pushRouter(Rotas.ETAPAS.nome,
					{
						identificador: this.state.identificador,
						modulo: modulo,
						localRealizacao: localRealizacao,
						etapa: etapa
					}
				)
			}).catch(error => {
			})
	},
	async [Actions.EXCLUIR_FOTO]({ commit, state }, { modulo, etapa, idComponente, foto }) {
		const { identificador, idChecklistResposta } = state;
		const moduloAtual = state.modulos.find(module => module.idChecklistModulo == modulo);
		const { idChecklistModulo, idChecklistModuloResposta, recebimentoFinalizado, etapas } = moduloAtual;

		const respostas = Actions.formatarRespostasEtapa(moduloAtual.etapas.componentes[etapa]);
		const etapaRespondida = Actions.obterEtapaRespondida(etapas, etapa, modulo);
		const dadosRequisicao = {
			dadosEtapa: {
				totalEtapas: etapas.totalEtapas,
				etapa: etapaRespondida
			},
			dadosResposta: {
				idChecklistResposta,
				idChecklistModuloResposta,
				recebimentoFinalizado,
				respostas
			},
			idChecklistModulo,
			idComponente,
			arquivos: foto

		}

		const { data: resposta } = await RequestProvider.post(`/excluirFotosChecklistModular/${identificador}`, dadosRequisicao)
		commit(Mutations.DEFINE_IMAGENS, resposta)
		return resposta
	},
	async [Actions.ENVIAR_EMAIL_PDF]({ state }, { email, idChecklistModuloResposta, solicitante }) {
		const { identificador } = state;
		const { data: resposta } = await RequestProvider.post(`/enviarEmailPdfChecklistModular/${identificador}`, { email, idChecklistModuloResposta, solicitante })
		return resposta
	}
}

const mutations = {
	[Mutations.DEFINE_PREVIEW](state, preview) {
		state.preview = preview
	},
	[Mutations.DEFINE_MODULOS](state, { modulos, dadosResposta }) {
		Object.keys(modulos).forEach(key => {
			if (modulos[key].moduloHabilitado == 'false' || !modulos[key].moduloHabilitado) return

			const moduloAux = modulos[key];
			const modulo = new Object();

			modulo.idChecklistModulo = moduloAux.idChecklistModulo;
			modulo.idChecklistModuloResposta = state.preview == false ? dadosResposta.modulos[key]?.idChecklistModuloResposta : null;
			modulo.localRealizacao = moduloAux.localRealizacao;
			modulo.ordem = state.preview == false ? dadosResposta.modulos[key]?.ordem : 1;
			modulo.recebimentoFinalizado = state.preview == false ? dadosResposta.modulos[key]?.recebimentoFinalizado : 'N';
			modulo.dataHorarioFinalizacao = state.preview == false ? dadosResposta.modulos[key]?.dataHorarioFinalizacao : null;
			modulo.pdfModulo = state.preview == false ? dadosResposta.modulos[key]?.pdfModulo : null;

			modulo.etapas = new Object();
			modulo.etapas.totalEtapas = Object.keys(moduloAux.etapas).length;
			modulo.etapas.etapasRespondidas = state.preview == false ? dadosResposta.modulos[key]?.etapasRespondidas : null;

			Object.keys(moduloAux.etapas).forEach(key => {
				const componentes = moduloAux.etapas[key]
				Object.keys(componentes).forEach(subkey => {
					const subcomponente = componentes[subkey];
					subcomponente.componenteMenu = Object.values(moduloAux.etapas[key]).filter(co => EtapasComponentesConstant.ETAPAS[co.chave]).map(c => c.chave)
				});
				Object.keys(componentes).forEach(subkey => {
					const subcomponente = componentes[subkey];
					if(!subcomponente.componenteHabilitado) {
						delete moduloAux.etapas[key][subkey]
						return
					}

					subcomponente.respostaAlterada = false;
					if (subcomponente.possuiSubcomponentes) {
						Object.keys(subcomponente.opcoes).forEach(subsubkey => {
							const subsubcomponente = subcomponente.opcoes[subsubkey];
							subsubcomponente.respostaAlterada = false;
						});
					}
				});
			});

			modulo.etapas.componentes = moduloAux.etapas;

			for (let key in moduloAux.assinaturas) {
				const assinatura = moduloAux.assinaturas[key]
				modulo.assinaturas = assinatura
			}

			state.modulos.push(modulo)
		});

		state.modulos.sort((a, b) => a.ordem - b.ordem)
	},
	[Mutations.DEFINE_RECEBIMENTO_FINALIZADO](state, dadosResposta) {
		state.idChecklistResposta = dadosResposta.idChecklistResposta;
		state.recebimentoFinalizado = dadosResposta.recebimentoFinalizado;
		state.dataHorarioFinalizacao = dadosResposta.dataHorarioFinalizacao;
	},
	[Mutations.DEFINE_DADOS_ATENDIMENTO](state, dadosAtendimento) {
		state.dadosAtendimento = ComponenteDadosAtendimentoService.trataDadosAtendimento(dadosAtendimento)
	},
	[Mutations.DEFINE_DADOS_PRESTADOR](state, dadosPrestador) {
		state.dadosPrestador = dadosPrestador
	},
	[Mutations.DEFINE_CHECKLIST_RESPOSTA](state, { idChecklistModulo }) {
		const indexModulo = state.modulos.findIndex(module => module.idChecklistModulo == idChecklistModulo)
		state.modulos[indexModulo].recebimentoFinalizado = 'S';
		state.modulos[indexModulo].dataHorarioFinalizacao = new Date().toLocaleString('pt-BR');
		setTimeout(() => {
			FuncoesHelper.pushRouter(Rotas.MODULOS.nome, { identificador: this.identificador })
		}, 3000)
	},
	[Mutations.DEFINE_ETAPA_SALVA](state, { idChecklistResposta, idChecklistModuloResposta, idChecklistModuloEtapaResposta, recebimentoFinalizado, respostas }) {
		state.idChecklistResposta = idChecklistResposta;
		state.idChecklistModuloResposta = idChecklistModuloResposta;
		state.recebimentoFinalizado = recebimentoFinalizado;

		const indexModulo = state.modulos.findIndex(module => module.idChecklistModuloResposta == idChecklistModuloResposta)
		const { etapa } = respostas;
		const etapaExistente = state.modulos[indexModulo].etapas.etapasRespondidas?.find(e => e.idEtapa === etapa) ?? null;

		if (etapaExistente) {
			etapaExistente.idChecklistModuloEtapaResposta = idChecklistModuloEtapaResposta
		} else {
			const etapasRespondidas = { idEtapa: parseInt(etapa), idChecklistModuloEtapaResposta }
			if (state.modulos[indexModulo].etapas.etapasRespondidas) {
				state.modulos[indexModulo].etapas.etapasRespondidas.push(etapasRespondidas)
			} else {
				state.modulos[indexModulo].etapas['etapasRespondidas'] = [etapasRespondidas]
			}
		}

		const componentesEtapa = state.modulos[indexModulo].etapas.componentes[etapa];
		Object.values(componentesEtapa).forEach(componente => {
			componente.respostaAlterada = false;
			if (componente.possuiSubcomponentes) {
				Object.values(componente.opcoes).forEach(subcomponente => {
					subcomponente.respostaAlterada = false;
				});
			}
		});
	},
	[Mutations.DEFINE_IMAGENS](state, { dadosEtapa, respostas, idComponente }) {
		const { idEtapa, idChecklistModuloEtapaResposta, idChecklistModulo } = dadosEtapa.etapa;
		const indexModulo = state.modulos.findIndex(module => module.idChecklistModulo == idChecklistModulo)
		const etapaExistente = state.modulos[indexModulo].etapas.etapasRespondidas?.find(e => e.idEtapa === idEtapa) ?? null;

		if (etapaExistente) {
			etapaExistente.idChecklistModuloEtapaResposta = idChecklistModuloEtapaResposta
		} else {
			const etapasRespondidas = { idEtapa: parseInt(idEtapa), idChecklistModuloEtapaResposta }
			if (state.modulos[indexModulo].etapas.etapasRespondidas) {
				state.modulos[indexModulo].etapas.etapasRespondidas.push(etapasRespondidas)
			} else {
				state.modulos[indexModulo].etapas['etapasRespondidas'] = [etapasRespondidas]
			}
		}

		state.modulos[indexModulo].etapas.componentes[idEtapa][idComponente].respostas = respostas[idComponente].respostas;
	},
	[Mutations.DEFINE_TIPO_VEICULO](state, tipoVeiculo) {
		state.tipoVeiculo = tipoVeiculo
	},
	[Mutations.DEFINE_COORDENADAS_TEMP](state, coordenadas) {
		state.coordenadasTemp = coordenadas;
	}
}

export default createStore({
	state,
	actions,
	mutations,
})

export const key = Symbol()
export function useStore() {
	return vuexUseStore(key)
}
